import { post, get } from "../util/crmAxios";
import { getBasicUrls } from "../util/config";
import { getCookie } from "../util/cookie";
import md5 from 'js-md5';
const caseSource = Number(getCookie('caseSource')) || 1;
const time = Date.parse(new Date());
const sign = md5(`${time}n9EXd3sDwSYlu8MgZAyB`);
const erpUrl = getBasicUrls().erpUrl;
//省市区
export const areaTree = (params) => get(`${getBasicUrls().treeApi}manage/base/area/tree`, params);
//省市
export const pctree = (params) => get(`${getBasicUrls().schoolmApi}manage/base/area/pctree`, params);

//案例管理-案例列表
export const queryScoreCaseListByPage = (params) => post('/erp/scoreCase/queryScoreCaseListByPage', params);
//案例管理-批量发布或下架
export const batchPublishOrOffShelf = (params) => post('/erp/scoreCase/batchPublishOrOffShelf', params);

//查询指定学员首末学习时间
export const queryStartEndScheduleByStudentId = (params) => get('/erp/classschedule/queryStartEndScheduleByStudentId', params);

//查询班主任和责任人
export const queryTeacherList = caseSource === 2 ? (params) => post(`${erpUrl}queryTeacherList`, { time, sign, param: params }) : (params) => post('/erp/classschedule/queryTeacherList', params);

//查询学员学习前后成绩
export const queryScoreListByStudentId = caseSource === 2 ? (params) => post(`${erpUrl}queryScoreListByStudentId`, { time, sign, param: params }) : (params) => get('/erp/examResult/queryScoreListByStudentId', params);

//查询学员学习轨迹
export const queryStudentLearnTrackList = (params) => post('/erp/studentdetail/queryStudentLearnTrackList', params);

//查询学员上课数
export const queryStudentCostHours = caseSource === 2 ? (params) => post(`${erpUrl}queryStudentCostHours`, { time, sign, param: params }) : (params) => post('/erp/school/queryStudentCostHours', params);

//查询学员实际学习情况
export const queryStudentLearnSituation = (params) => post('/erp/topic/queryStudentLearnSituation', params);

//查询学员课程学习情况
export const queryCourseLearnSituation = (params) => post('/erp/topic/queryCourseLearnSituation', params);

//根据账号查询学员列表
export const saveOrUpdate = (params) => post('/erp/scoreCase/saveOrUpdate', params);

//查询案例详情
export const queryDetailById = (params) => get('/erp/scoreCase/queryDetailById', params);

//根据账号查询学员列表
export const queryStudentListByAccountUser = caseSource === 2 ? (params) => post(`${erpUrl}queryStudentListByAccountUser`, { time, sign, param: params }) : (params) => post('/erp/student/queryStudentListByAccountUser', params);

//没有provinceId和cityId则调用
export const queryLocationByMobile = (params) => get('/erp/scoreCase/queryLocationByMobile', params);

//案例上榜
export const pushCaseToHot = (params) => post('/erp/scoreCase/pushCaseToHot', params);


export const updateStudentUpScore = (params) => post(`${erpUrl}updateStudentUpScore`, { time, sign, param: params.studentId });//erp

